import { render, staticRenderFns } from "./PayerConfirm.vue?vue&type=template&id=0895d032&scoped=true"
import script from "./PayerConfirm.vue?vue&type=script&lang=js"
export * from "./PayerConfirm.vue?vue&type=script&lang=js"
import style0 from "./PayerConfirm.vue?vue&type=style&index=0&id=0895d032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895d032",
  null
  
)

export default component.exports